var React = require('react');

function Top (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M64.5 122.6c32 0 58.1-26 58.1-58.1s-26-58-58.1-58-58 26-58 58 26 58.1 58 58.1zm0-108c27.5 0 49.9 22.4 49.9 49.9S92 114.4 64.5 114.4 14.6 92 14.6 64.5 37 14.6 64.5 14.6z","key":0}),React.createElement("path",{"d":"M70 93.5c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2 1.6-1.6 1.6-4.2 0-5.8L52.3 64.2l23.5-23.5c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8 0L43.6 61.3c-.8.8-1.2 1.8-1.2 2.9s.4 2.1 1.2 2.9L70 93.5z","key":1})]);
}

Top.defaultProps = {"viewBox":"0 0 129 129"};

module.exports = Top;

Top.default = Top;
